/**
 * Environment-aware allowed origins configuration for secure redirects
 * Uses current origin and common development ports to avoid hardcoded domains
 */

const getEnvironmentOrigins = (): string[] => {
  const currentOrigin = window.location.origin;
  const environment =
    window.runTimeEnvs.VITE_SENTRY_ENVIRONMENT || 'development';

  // Always allow the current origin
  const allowedOrigins = [currentOrigin];

  // For development environments, also allow common localhost ports
  if (
    environment.toLowerCase() === 'development' ||
    environment.toLowerCase() === 'dev'
  ) {
    const commonDevPorts = [3000, 3001, 5173, 8080, 4173]; // Vite, React, common dev ports
    const localhostOrigins = commonDevPorts.map(
      port => `http://localhost:${port}`,
    );
    const localhostIPOrigins = commonDevPorts.map(
      port => `http://127.0.0.1:${port}`,
    );

    allowedOrigins.push(...localhostOrigins, ...localhostIPOrigins);
  }

  return allowedOrigins;
};

export const getAllowedOrigins = (): string[] => {
  return getEnvironmentOrigins();
};
